/**
 * Keeps `postcode` and `post_code` in sync on organisation.address (API uses both in places).
 * @param {{ organisation?: { address?: Record<string, unknown> } }} values
 */
export function syncOrganisationPostcodeFields(values) {
	if (!values?.organisation?.address) return;
	const addr = values.organisation.address;
	const pc = String(addr.postcode || addr.post_code || "").trim();
	if (!pc) return;
	addr.postcode = pc;
	addr.post_code = pc;
}
